import React from 'react';
import { observer } from 'mobx-react';
import { AntSelect } from 'controls/react/ant/ant-select/antSelect';
import { AntSelectPropsGeneric, fieldNamesIdName } from 'controls/react/ant/ant-select/types';
import { ApiRequest, useRemoteListForSelect } from 'framework/api';
import { i18n } from 'core/localization';
import { Account } from 'areas/administration/accounts/types';

export type LoginAccountSelectorProps = AntSelectPropsGeneric<string> & {
	accountId?: string;
};

export const LoginAccountSelector = observer(({ accountId, ...rest }: LoginAccountSelectorProps) => {
	const remoteData = useRemoteListForSelect(
		new ApiRequest<Account[]>({
			url: 'subaccounts/firstLevel/?ignoreTags=true',
			accountBased: true,
			accountId,
		}),
	);

	return (
		<AntSelect placeholder={i18n('Select account...')} fieldNames={fieldNamesIdName} {...remoteData} {...rest} />
	);
});
